import axios from "axios";
import Cookies from "js-cookie";
import { RESOURCE, STORAGE } from "../apiConstant";
import BaseApi from "../baseApi";

class ResourceApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getFile(url, onDownloadProgress, signal) {
    return axios.get(`${url}?token=${Cookies.get("access_token")}`, {
      responseType: "blob",
      onDownloadProgress: onDownloadProgress,
      signal,
    });
  }

  getFreeFile(url, onDownloadProgress, signal) {
    return axios.get(url, {
      responseType: "blob",
      onDownloadProgress: onDownloadProgress,
      signal,
    });
  }

  summaryAll(body) {
    return this.post(`${RESOURCE}/summary/all`, body);
  }

  summaryByProgram(body) {
    return this.post(`${RESOURCE}/summary/program`, body);
  }

  remove(body) {
    return this.post(`${RESOURCE}/remove`, body);
  }

  storeFile(body) {
    return this.post(`${RESOURCE}/store`, body);
  }

  deleteFiles(body, abortController) {
    return this.post(`${RESOURCE}/delete-files`, body, {
      signal: abortController,
    });
  }

  uploadChunk(body) {
    return this.post(`${RESOURCE}/upload-chunk`, body);
  }

  uploadChunkV2(file, resourceRequest, config = {}) {
    const formData = new FormData();

    formData.append("file", file);

    const metadataBlob = new Blob([JSON.stringify(resourceRequest)], {
      type: "application/json",
    });
    formData.append("metadata", metadataBlob);

    return this.post(`${RESOURCE}/upload-chunk-v2`, formData, {
      timeout: 100000,
      ...config,
      headers: {
        ...(config.headers || {}),
        "Content-Type": undefined,
      },
    });
  }

  getStreamFileAsBlob(resourceId, onDownloadProgress, signal, headers = {}) {
    return this.get(`${RESOURCE}/file/${resourceId}`, null, {
      responseType: "blob",
      onDownloadProgress,
      signal,
      headers,
    });
  }

  getVideoTicket(resourceId, signal) {
    return this.get(`${RESOURCE}/video/ticket/${resourceId}`, null, {
      signal,
    });
  }

  downloadFile(resourceId, onDownloadProgress, signal, headers = {}) {
    return this.get(`${RESOURCE}/file/download/${resourceId}`, null, {
      responseType: "blob",
      onDownloadProgress,
      signal,
      headers,
      returnFullResponse: true,
    });
  }

  getResourcesPanel(conversationId) {
    return this.get(`${RESOURCE}/panel/${conversationId}`);
  }

  getResourcesArchiveType(body) {
    return this.post(`${RESOURCE}/panel/archive`, body);
  }

  getResourcesHistory(body) {
    return this.post(`${RESOURCE}/history/viewer`, body);
  }

  getStorage(body) {
    return this.post(`${RESOURCE}/storage`, body);
  }

  deleteStorage(body) {
    return this.post(`${RESOURCE}/storage/delete`, body);
  }

  getActContentType() {
    return this.get(`${RESOURCE}/get-content-type`);
  }

  prepareZip(resourceIds) {
    return this.post(`${RESOURCE}/zip/prepare`, { resourceIds });
  }

  async downloadCompressFile(
    resourceIds,
    onDownloadProgress,
    signal,
  ) {
    const result = await this.prepareZip(resourceIds);

    if (result?.status !== 200 || !result?.data) {
      throw new Error(result?.message || "Prepare files for download failed");
    }

    return axios.get(result.data, {
      responseType: "blob",
      onDownloadProgress,
      signal,
    });
  }

  deletePhysicalFilesByDateRange(body) {
    return this.post(`${RESOURCE}/delete-physical-files`, body);
  }

  createMultipart(body) {
    return this.post("secure" + STORAGE + "create-multipart", body);
  }

  createPartUrl(body) {
    return this.post("secure" + STORAGE + "create-part-url", body);
  }

  complete(body) {
    return this.post("secure" + STORAGE + "complete", body);
  }

  abort(body) {
    return this.post("secure" + STORAGE + "abort", body);
  }

  uploadFile(presignedUrl, file, config) {
    return axios.put(presignedUrl, file, {
      headers: {
        "Content-Type": "application/octet-stream",
      },
      ...config,
    });
  }
}

export default ResourceApi;
